// Central configuration — edit these before going live.
export const SITE = {
  // Shown at top of the form
  heading: "Complete your details",
  // Family photo shown as the hero image on the main page
  heroPhoto: "https://customer-assets-jai6qajn.emergentagent.net/job_mum-tomorrows/artifacts/cb116cj8_IMG_4351.JPEG",
  // Purchase options — single ticket or a discounted bundle.
  // Prices are enforced server-side; these are for display only.
  priceOptions: [
    { id: "single", label: "Single ticket", tickets: 1, price: 20 },
    { id: "bundle", label: "Bundle of 3", tickets: 3, price: 50, tag: "Save $10" },
  ],
  // Osko details for manual bank transfer
  payeeName: "Mitchell Keighrey",
  payId: "0467 260 193",
  payIdType: "Mobile",
  // Support contact shown on the thank-you page
  contactEmail: "admin@keighreycivil.com.au",
};

export const STORY = {
  intro:
    "In September 2022, a routine pregnancy blood test turned into the day everything changed.",
  chapters: [
    {
      label: "Sept 2022",
      title: "The diagnosis",
      body:
        "Casey was diagnosed with Primary Myelofibrosis, a rare and incurable blood cancer. For three years she has quietly faced weekly treatment while raising two little boys and trying to keep life feeling normal.",
    },
    {
      label: "Earlier this year",
      title: "The cancer became aggressive",
      body:
        "Her only chance at a future now is a stem cell transplant — intensive chemotherapy to destroy her immune system, followed by donor stem cells and around 100 days in hospital and strict isolation while her body rebuilds.",
    },
    {
      label: "The road ahead",
      title: "Months apart from her boys",
      body:
        "Her husband, White, will become her full-time carer, while the family faces being separated from their two young boys for extended periods — alongside months without work, accommodation in Melbourne, travel costs, and real financial pressure. Their wish is simple: get through the transplant, come home healthy, and keep watching their boys grow up.",
    },
    {
      label: "About this campaign",
      title: "Why we are doing this",
      body:
        "As friends of Casey and her family, Keighrey Civil is proud to have organised this campaign to ease the financial pressure on this young family so they can focus on what matters most — her recovery. Every contribution helps support them through the months ahead. 100% of proceeds go directly towards Casey's treatment and supporting her young family.",
    },
  ],
  outro:
    "Thank you for your generosity, your kindness, and for helping this family get home to each other.",
  signoff: "Organised by Keighrey Civil, friends of Casey.",
};

// Donor acknowledgements shown at the bottom of the page.
export const DONORS = {
  heading: "With thanks to our donors",
  logos: [
    { name: "Delcon Group", src: "/donors/delcon.png" },
    { name: "Proquip", src: "/donors/proquip.png" },
    { name: "Cobra Civil", src: "/donors/cobra.png" },
    { name: "MD Concrete Solutions", src: "/donors/md.png" },
    { name: "Keighrey Civil", src: "/donors/keighrey.png", dark: true },
  ],
  extra: "and some anonymous donors",
};

// Group image + prize descriptions shown below the payment section.
export const PRIZES = {
  groupPhoto:
    "https://customer-assets-jai6qajn.emergentagent.net/job_mum-tomorrows/artifacts/52318686a24e69a9_image.png",
  intro: "Three prize packs. Ten prizes. All donated by local businesses.",
  items: [
    {
      place: "1st",
      title: "The Ultimate Setup",
      value: "6 prizes · one winner",
      contents: [
        "Engel 60L Fridge/Freezer",
        "Dewalt 6-piece 18V–54V 9.0Ah Cordless Kit",
        "Ryobi 212cc Petrol Inverter Generator",
        "Stihl MS250 Chainsaw",
        "Adrenaline Adventures Voucher",
        "$250 Bunnings Voucher",
      ],
    },
    {
      place: "2nd",
      title: "Makita Kit & Bunnings Voucher",
      value: "2 prizes · one winner",
      contents: [
        "Makita 6-piece Cordless Kit",
        "$250 Bunnings Voucher",
      ],
    },
    {
      place: "3rd",
      title: "Signed Hodge Memorabilia & Woolworths Voucher",
      value: "2 prizes · one winner",
      contents: [
        "Luke Hodge signed Hawthorn Jumper and Footy",
        "$500 Woolworths Voucher",
      ],
    },
  ],
};
